import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminTourManagementPage from './pages/AdminTourManagementPage';
import AdminGalleryManagementPage from './pages/AdminGalleryManagementPage';
import AdminCustomToursPage from './pages/AdminCustomToursPage';
import AdminCustomTourInterestsPage from './pages/AdminCustomTourInterestsPage';
import AdminRegistrationsPage from './pages/AdminRegistrationsPage';
import ProtectedRoute from './components/admin/ProtectedRoute';
import HomePage from './pages/HomePage';
import PaymentPage from './pages/PaymentPage';
import AboutPage from './pages/AboutPage';
import CancellationPolicyPage from './pages/CancellationPolicyPage';
import TourDetailsPage from './pages/TourDetailsPage';
import ToursPage from './pages/ToursPage';
import RegistrationPage from './pages/RegistrationPage';
import GalleryPage from './pages/GalleryPage';
import ReviewsPage from './pages/ReviewsPage';
import ScrollToTop from './components/ScrollToTop';
import './styles/globals.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            {/* Tour routes */}
            <Route path="/tours/:tourId" element={<TourDetailsPage />} />
            <Route path="/tours" element={<ToursPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/refund-policy" element={<CancellationPolicyPage />} />
            <Route path="/cancellation-policy" element={<CancellationPolicyPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/registration" element={<RegistrationPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedRoute>
                  <AdminDashboardPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/tours" 
              element={
                <ProtectedRoute>
                  <AdminTourManagementPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/gallery" 
              element={
                <ProtectedRoute>
                  <AdminGalleryManagementPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/custom" 
              element={
                <ProtectedRoute>
                  <AdminCustomToursPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/custom-interests" 
              element={
                <ProtectedRoute>
                  <AdminCustomTourInterestsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/registrations" 
              element={
                <ProtectedRoute>
                  <AdminRegistrationsPage />
                </ProtectedRoute>
              } 
            />
            <Route path="/new-tours" element={<div className="min-h-screen flex items-center justify-center"><h1 className="heading-primary">New Tours - Coming Soon</h1></div>} />
            {/* 404 Route */}
            <Route path="*" element={<div className="min-h-screen flex items-center justify-center"><h1 className="heading-primary text-error">404 - Page Not Found</h1></div>} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
